export const project = [
    {
        label: 'SACP',
        id: '1'
    },
    {
        label: 'RAINS',
        id: '2'
    }
];

export const agency = [
    {
        label: 'BADC',
        id: '1'
    },
    {
        label: 'BARI',
        id: '2'
    },
    {
        label: 'DAE',
        id: '3'
    },
    {
        label: 'DAM',
        id: '4'
    },
    {
        label: 'FAO',
        id: '5'
    },
    {
        label: 'GAIN',
        id: '6'
    }
];

export const demonstrationSubActivities = [
    { label: "Solar Pump Based Solar home system ( Pumpset with Accessories ) supply with Installation", id: "54" },
    { label: "Follow-up and maintenance service charge for solar home system", id: "55" },
    { label: "Special support for Summer Tomato cultivation at farmers level", id: "5" },
    { label: "Fruit Garden demonstration", id: "1" },
    { label: "Homestead Vegetables Garden setup (Special Program- RPSF I)", id: "4" },
    { label: "Others demonstration (Pulses/oils/maize/vermi-compost)", id: "3" },
    { label: "Quick Impact inputs to household and lead farmers to increase food security and access to Market (Special Program- RPSF II)", id: "6" },
    { label: "Vegetables demonstration", id: "2" },
];
